<template>
  <div class="briefing_report">
    <CCard class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Tra cứu báo cáo của Sở</span>
        <vs-button
          v-if="CheckRole(246) === true"
          square
          class="float-right md:mt-2"
          to="/briefingcollections/create"
          ><i class="bx bx-plus"></i> &nbsp; Thêm báo cáo</vs-button
        >
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow class="mb-2">
          <CCol sm="2" />
          <CCol sm="2" class="mb-2">
            <label class="mb-1">Năm</label>
            <CInput v-model="inputYear" type="number" />
          </CCol>
          <CCol sm="2" class="mb-2">
            <label class="mb-1">Tháng</label>
            <CSelect
              :value.sync="inputMonth"
              :options="months"
              @change="getData"
            />
          </CCol>
          <CCol sm="3" class="mb-2">
            <label class="mb-1">Phòng ban</label>
            <CSelect :value.sync="inputDepartment" :options="listDepartment" @change="getData"/>
          </CCol>
          <CCol sm="2">
            <label class="mb-0">&nbsp;</label>
            <vs-button warn square class="custom_btn_search" @click="getData">
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
          </CCol>
          <CCol sm="2" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="tableData"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
        }"
        compactMode
        :line-numbers="true"
        styleClass="vgt-table bordered striped"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'file'" class="center">
            <vs-tooltip color="square">
              <vs-button
                transparent
                @click="displayFile(props.row)"
                square
                circle
                icon
                ><i class="bx bxs-file"></i
              ></vs-button>
              <template #tooltip>
                Xem file đính kèm
              </template>
            </vs-tooltip>
          </div>
          <div v-else-if="props.column.field === 'index'">
            <span>{{ props.row.originalIndex + 1 }}</span>
          </div>
          <div v-else-if="props.column.field === 'briefings_month'">
            <span>Tháng {{ props.row.briefings_month }}</span>
          </div>
          <div v-else-if="props.column.field === 'Action'" class="row">
              <vs-tooltip color="success" class="ml-auto">
                <template #tooltip>
                  Sửa thông tin
                </template>
                <vs-button
                  @click="editData(props.row.id)"
                  transparent
                  gradient
                  success
                  circle
                  icon
                  ><i class="bx bx-pencil"></i
                ></vs-button>
              </vs-tooltip>
              <vs-tooltip color="danger" class="mr-auto">
                <template #tooltip>
                  Xóa dữ liệu
                </template>
                <vs-button
                  @click="confirmDelete(props.row.id)"
                  transparent
                  gradient
                  danger
                  circle
                  icon
                  ><i class="bx bx-trash"></i
                ></vs-button>
              </vs-tooltip>
          </div>
        </template>
      </vue-good-table>
    </CCard>
    <!-- Delete promt -->
    <vs-dialog prevent-close width="450px" v-model="state.dialog.delete">
      <template #header>
        <h4 class="not-margin">Xác nhận</h4>
      </template>
        <span class="center">Bạn có chắc chắn muốn xóa khỏi hệ thống?</span>
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button transparent danger @click="deleteData()">
            Xóa
          </vs-button>
          <vs-button @click="state.dialog.delete = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <!-- show list file -->
    <vs-dialog prevent-close width="650px" v-model="state.dialog.files">
      <ListFile :file_data="this.file_data" />
    </vs-dialog>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapState,mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import ListFile from "../../../components/files/ListFile";
const api = ClientFactory.get("briefingCollection");
const apiDropdown = ClientFactory.get("dropdowns");

export default {
  components: {
    VueGoodTable,
    ListFile,
  },
  data() {
    return {
      state: {
        dialog: {
          delete: false,
          files: false,
        },
        deleteId: -1,
      },
      inputYear: new Date().getFullYear(),
      inputMonth: new Date().getMonth() + 1,
      inputDepartment: -1,
      tableData: [],
      file_data: [],
      listDepartment: [],
    };
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    columns() {
      const cols = [
        {
          label: "Tên báo cáo",
          field: "report_title",
        },
        {
          label: "Phòng ban",
          field: "department_name",
          
        },
        {
          label: "Thời gian",
          field: "briefings_month",
          thClass: "text-center",
          width: "100px",
        },
        {
          label: "File",
          field: "file",
          thClass: "text-center",
          width: "50px",
        },
        {
          label: "Ngày nộp",
          field: "report_date",
          type: "date",
          dateInputFormat: "dd/MM/yyyy",
          dateOutputFormat: "dd/MM/yyyy",
          thClass: "text-center",
          width: "100px",
        },
        {
          label: "Người nộp",
          field: "created_user",
          thClass: "text-center",
          width: "95px",
        }
      ]

      if(this.CheckRole(246)) {
        cols.push({
            label: "Thao tác",
            field: "Action",
            tdClass: "text-center",
            thClass: "text-center",
            width: "100px",
        })
      }
      return cols;
    },
    months() {
      return [
        {
          label: "Tháng 1",
          value: 1,
        },
        {
          label: "Tháng 2",
          value: 2,
        },
        {
          label: "Tháng 3",
          value: 3,
        },
        {
          label: "Tháng 4",
          value: 4,
        },
        {
          label: "Tháng 5",
          value: 5,
        },
        {
          label: "Tháng 6",
          value: 6,
        },
        {
          label: "Tháng 7",
          value: 7,
        },
        {
          label: "Tháng 8",
          value: 8,
        },
        {
          label: "Tháng 9",
          value: 9,
        },
        {
          label: "Tháng 10",
          value: 10,
        },
        {
          label: "Tháng 11",
          value: 11,
        },
        {
          label: "Tháng 12",
          value: 12,
        },
      ]
    },
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async getData() {
      this.tableData = [];

      this.loading(this.$vs);
      const { data } = await api.searchReport(
          "",
          this.inputMonth,
          this.inputYear,
          this.inputDepartment
        );

      this.checkResponseData(data);
      this.closeLoading();
    },
    checkResponseData(data) {
      if(data.status == "success")
      { 
        if(data.data[0].id != undefined) {
          this.tableData = data.data;
        } else {
          this.tableData = [];
        }
      }else{
        if(data.message != "Xin lỗi, không có dữ liệu"){
          this.notify({
            error:true,
            title: "Thông báo",
            text: data.message
          });
        }
      }
    },
    editData(id) {
      this.$router
        .push({ path: `/briefingcollections/edit/${id}` })
        .catch(() => {});
    },
    confirmDelete(id) {
      this.deleteId = id;
      this.state.dialog.delete = true;
    },
    async deleteData() {
      this.loading(this.$vs);
      let response = await api.delReport(this.deleteId);
      if (
        typeof response.error !== "undefined" ||
        response.data.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: response.error || response.data.message,
        });
      } else {
        this.closeLoading();
        this.state.dialog.delete = false;
        await this.getData();
        return this.notify({
          text: "Xóa dữ liệu thành công",
        });
      }
    },

    async displayFile(files) {
      console.log(files)
      this.loading(this.$vs);
      let result = await api.getfileReport(files.id);
      console.log(result)
      if (result.status == "success") {
        let data = [];
        let dt = {};
        for (let index = 0; index < result.data.length; index++) {
          dt = {};
          dt.file_name = result.data[index].file_name;
          dt.file_url = result.data[index].file_path;
          data.push(dt);
        }
        this.file_data = data;
      } else {
        this.file_data = [];
      }
      this.closeLoading();
      //show dialog
      this.state.dialog.files = true;
      
    },
    CheckRole(id) {
      return this.AppActiveUser.role.includes(id);
    },
    GoPagesError() {
      this.notify({
        error: true,
        title: "Permission",
        text: "Bạn không có quyền truy cập trang này",
      });
      this.$router
        .push({
          path: "/pages/not-authorized",
        })
        .catch(() => {});
    },
    /**
     * Lấy danh sách tất cả phòng ban. Dùng cho dropdown
     */
    async getDepartments() {
      let listDepartment = await apiDropdown.get("departments");
      for (var i = 0; i < listDepartment.length; i++) {
        if (listDepartment[i].value == 0) {
          listDepartment[i].value = -1;
          listDepartment[i].label = "Tất cả";
        }
      }
      return listDepartment;
    },
  },
  async created() {
    if (this.CheckRole(247) === false) {
      this.GoPagesError();
    } else {
      this.listDepartment = await this.getDepartments();
      await this.getData();
    }
  },
  destroyed() {
    this.closeLoading();
  },

};
</script>

<style lang="scss">
.briefing_report {
  table.vgt-table td {
    vertical-align: inherit;
    color: black !important;
    font-size: 14.5px;
    //padding: 0.3rem !important;
    padding: 0em 0.75em 0em 0.75em;
  }
  .vgt-responsive {
    overflow-x: inherit;
  }
}
</style>
